import { makeStyles,useTheme } from '@material-ui/core/styles';
import theme from 'theme';

export const useStyles = makeStyles(theme=> ({
  input: {
    paddingTop: '24px',
    width: '255px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  inputRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
    },
  }
}));
